import ModelAbstract from './ModelAbstract';
import { CollectionStatus } from '../modules/Enumeration';

class FigureCollection extends ModelAbstract {
    constructor({
        id = null,
        figureId = null,
        userId = null,
        collection = CollectionStatus.NONE,
        grailRank = null,
        position = null,
        createdAt = null,
        updatedAt = null,
    } = {}) {
        super({ id, createdAt, updatedAt });
        this.figureId = figureId;
        this.userId = userId;
        this.collection = collection;
        this.grailRank = grailRank;
        this.position = position;
    }

    /**
     * Factory method to create a FigureCollection instance from API response
     * @param {Object} data - Raw figure collection data from API
     * @returns {FigureCollection} - Instantiated FigureCollection object
     */
    static fromAPI(data) {
        if (!data) return null;
        
        return new FigureCollection({
            id: data.id,
            figureId: data.figure?.id,
            userId: data.user?.id,
            collection: data.collection || CollectionStatus.NONE,
            grailRank: data.grailRank,
            position: data.position,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
        });
    }

    /**
     * Is this figure a grail?
     * @returns {boolean} True if the figure is marked as a grail
     */
    isGrail() {
        return this.grailRank !== null && this.grailRank > 0;
    }

    /**
     * Convert to plain object for JSON serialization
     */
    toJSON() {
        return {
            ...super.toJSON(),
            figureId: this.figureId,
            userId: this.userId,
            collection: this.collection,
            grailRank: this.grailRank,
            position: this.position,
        };
    }
}

export default FigureCollection;
export { FigureCollection }; 